var _style, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _ellipse, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OBJECTS",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 261.9 289.4",
    style: {
      enableBackground: "new 0 0 261.9 289.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000029727977635440050720000010650142799767084986_);}\r\n\t.st1{fill:#272726;}\r\n\t.st2{fill:#313130;}\r\n\t.st3{fill:#0A936F;}\r\n\t.st4{fill:#0D8C6E;}\r\n\t.st5{fill:#00C39A;}\r\n\t.st6{fill:#3E3E3E;}\r\n\t.st7{fill:#323231;}\r\n\t.st8{fill:#494949;}\r\n\t.st9{fill:#353535;}\r\n\t.st10{fill:#595959;}\r\n\t.st11{fill:#4C4C4C;}\r\n\t.st12{fill:#E2CAB9;}\r\n\t.st13{fill:#6A5251;}\r\n\t.st14{fill:#3B3B3B;}\r\n\t.st15{fill:url(#SVGID_00000021109223711713623050000011126538396294303637_);}\r\n\t.st16{fill:#919190;}\r\n\t.st17{fill:#343434;}\r\n\t.st18{fill:#3C3C3C;}\r\n\t.st19{opacity:0.24;fill:#3C3C3C;}\r\n\t.st20{fill:#F8EADD;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 134.3,
    cy: 129.5,
    r: 152.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000121253273427976304920000018306135614560187280_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000121253273427976304920000018306135614560187280_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M93.5,190.9h84.3c0,0-27.6,123.6-35.9,133.1c-17.1-22.3-48.8-131.6-48.8-131.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M112.2,190.9h50.6c0,0-16.6,123.6-21.6,133.1c-10.3-22.3-29.3-131.6-29.3-131.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M149.4,213.2c-1.3,5.3-5.7,19-6.2,19.1c-1.4,0.2-6.6,0.5-9.8,0c-0.3-0.1-6.8-11.7-8.5-17.5 c2.5-1.7,6.4-4.3,12.5-4.4C148.1,210.2,149.4,213.2,149.4,213.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M137.5,210.4c-6.1,0.1-10,2.7-12.5,4.4c0.7,2.3,2.1,5.6,3.6,8.7c4.8-3.1,10.2-4.4,10.2-4.4s3.7,1.5,7.5,4.7 c1.2-3.9,2.5-8.1,3-10.5C149.4,213.2,148.1,210.2,137.5,210.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M154.2,269.5c-1.3-19.4-10.9-37.2-10.9-37.2h-9.9c-4.2,8.5-9.1,27.7-8.9,37.2c-2.2,11.1,13.1,52.5,17.3,54.5 c5.6-5.7,10.1-25.4,11.7-35.1C155.2,279.2,154.2,269.5,154.2,269.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M147,240.1c-2-4.9-3.6-7.8-3.6-7.8h-9.9c-0.9,1.9-1.9,4.4-2.9,7.2C134.9,236.1,141.1,235.2,147,240.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M154.2,269.5c-0.3-4.7-1.1-9.2-2.1-13.5c-2.8,16.3-10.4,44.1-10.4,44.1s-11.7-30.8-15.7-43.7 c-1,5-1.6,9.6-1.5,13.1c-2.2,11.1,13.1,52.5,17.3,54.5c5.6-5.7,10.1-25.4,11.7-35.1C155.2,279.2,154.2,269.5,154.2,269.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M134.6,211.3c-7.5,4.1-14.1,9.9-19.1,16.8c-9.9-9.1-16.2-35.2-16.2-35.2C105.3,197.1,118,207.4,134.6,211.3z "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M158.6,228.1c-4.3-5.9-9.8-11.7-17.8-17.3c11.4-2.9,24.8-14.1,28.8-18.9 C171.4,209.2,158.6,228.1,158.6,228.1z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M112.1,201.7c-5.6-3.4-9.9-6.8-12.8-8.8c0,0,6.3,26.1,16.2,35.2c0-0.1,0.1-0.1,0.1-0.1 C109.8,221.2,109.9,211.3,112.1,201.7z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M169.6,192c-1.8,2.2-5.6,5.7-10.2,9.1c4.1,12.7,1.2,22.2-1,26.8c0.1,0.1,0.1,0.2,0.2,0.3 C158.6,228.1,171.4,209.2,169.6,192z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M258.2,225.4c-16.7-16.5-35.6-31.2-62.5-43.2c-5.4,2.5-32.3,57.7-30.6,90.5c0.9,16.9-19.8,45.4-23.3,51.3 C160.7,320.9,230,281.1,258.2,225.4z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M200.1,268.1l-10-21.8c0,0,11.8,0.5,17.1,0.9c1.3-11,4.6-35.7,1.9-58.6c-4.2-2.3-8.7-4.4-13.4-6.5 c-5.4,2.5-32.3,57.7-30.6,90.5c0.9,16.9-19.8,45.4-23.3,51.3C170.1,309,200.1,268.1,200.1,268.1z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M10.3,225.4c16.7-16.5,35.6-31.2,62.5-43.2c5.4,2.5,14.3,49.7,31.2,77.8c9.8,16.2,33.1,58.6,37.8,64 C107.5,318,25.8,275.3,10.3,225.4z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M63.6,186.5c0,0-10.9,39.2-7.6,63.9c6.7,0.6,15.9-3.8,15.9-3.8s-7.3,15.3-5.9,22.2 c1.5,6.9,57.8,45.6,75.8,55.1C109.4,273.8,96,222.5,96,222.5l-18.8-42.7C77.2,179.9,66.9,184.9,63.6,186.5z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M92.6,163.1C81.8,167.9,70,176.5,70,176.5s-3.7,61.2-3.3,61.5c0.3,0.3,24.2-3.1,24.2-3.1 c-4.8,7.2-9.1,14.8-12.8,22.6c-0.8,1.6-1.5,3.3-1.3,5c0.2,1.4,1,2.6,1.8,3.8c17.8,25.5,38.9,38.1,63.2,57.6 c-13.3-54.6-31.2-96-41.7-132.7C94.4,171.1,92.6,163.1,92.6,163.1z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M81.1,263.9c-0.8-1.2-1.6-2.4-1.8-3.8c-0.2-1.7,0.5-3.5,1.3-5c3.7-7.8,8-15.4,12.8-22.6 c0,0-23.9,3.4-24.2,3.1c-0.4-0.3,2.8-53.8,3.2-60.7c-1.5,1-2.4,1.7-2.4,1.7s-3.7,61.2-3.3,61.5c0.3,0.3,24.2-3.1,24.2-3.1 c-4.8,7.2-9.1,14.8-12.8,22.6c-0.8,1.6-1.5,3.3-1.3,5c0.2,1.4,1,2.6,1.8,3.8c17.8,25.5,38.9,38.1,63.2,57.6 c-0.4-1.8-0.9-3.6-1.3-5.4C117.9,300.7,97.9,288.1,81.1,263.9z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M175,163.1c10.7,4.7,20.7,13.4,20.7,13.4s3.7,61.2,3.3,61.5c-0.3,0.3-24.2-3.1-24.2-3.1 c7.2,13.1,14.3,25.9,14,27.7c-0.2,1.4-22.7,41.9-46.9,61.4c13.5-55,20.7-97.7,27.5-135.2C172.5,171,175,163.1,175,163.1z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M195.7,176.5c0,0-3.8-3.3-9.2-6.9c4.1,2.9,6.8,5.3,6.8,5.3s3.7,61.2,3.3,61.5c-0.3,0.3-24.2-3.1-24.2-3.1 c7.2,13.1,14.3,25.9,14,27.7c-0.2,1.3-20.6,38.1-43.4,58.4c-0.4,1.5-0.7,3-1.1,4.6c24.2-19.5,46.7-60,46.9-61.4 c0.2-1.7-6.9-14.5-14-27.7c0,0,23.9,3.4,24.2,3.1C199.3,237.7,195.7,176.5,195.7,176.5z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M114.6,235.3c-5.4-15.7-10.4-30.2-14.4-44.1c-5.7-20.2-7.6-28.2-7.6-28.2c-3.1,1.4-6.4,3.1-9.3,4.8 C81.8,191.8,95.6,219.7,114.6,235.3z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M175,163.1c0,0-2.5,7.9-5.7,25.6c-2.6,14.6-5.4,30.1-8.5,46.7c13.4-14.1,23.6-39.6,28.5-63.8 C185.5,168.8,180.3,165.5,175,163.1z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M178.2,139.3C178.2,139.3,178.2,139.4,178.2,139.3c0.1-0.9,0.2-1.8,0.3-2.7c-29.8,10.6-90.3,2.5-90.3,2.5 c0,0,0,0.1,0,0.2l-7.3-1.3c0.2,2.8,3.3,10.1,8.5,12.3c0-0.1,0-0.2,0.1-0.3c1.6,13.4,3.8,31.9,5,37.5c1.6,7.3,21.9,24.3,39.6,24.3 c17.7,0,38.2-16.3,40-24.3c2.2-9.5,2.6-24.1,3.4-37.3c0,0.1,0,0.1,0,0.2c5.2-2.1,8.3-9.4,8.5-12.3L178.2,139.3z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M177.5,150.2c5.2-2.1,8.3-9.4,8.5-12.3l-7.8,1.4c0,0,0,0,0,0c0.1-0.9,0.2-1.8,0.3-2.7 c-29.8,10.6-90.3,2.5-90.3,2.5c0,0,0,0.1,0,0.2l-7.3-1.3c0.2,2.8,3.3,10.1,8.5,12.3c0-0.1,0-0.2,0.1-0.3 c1.6,13.4,3.8,31.9,5,37.5c1.6,7.3,21.9,24.3,39.6,24.3c4.4,0,9-1,13.4-2.7c-7.6,1.6-19.2,1.7-24.3-3.7c-7-7.4-3.2-15-0.6-19 c11.5,0.6,17-4.1,17.9-7.1c-3.2,1.9-10.5,1.5-12.1-0.4c-5.6-6.6-1.5-12.6,15.1-11.6c19,1.1,28.7-1.2,33.2-3.1 c0.3-4.7,0.5-9.5,0.8-14.1C177.5,150.1,177.5,150.1,177.5,150.2z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st14",
    cx: 133.8,
    cy: 105.5,
    rx: 86,
    ry: 47.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142881589030235622480000003657423462233661117_",
    gradientUnits: "userSpaceOnUse",
    x1: 111.0313,
    y1: 122.9733,
    x2: 151.1685,
    y2: 87.6144
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3C3C3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#494949"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000142881589030235622480000003657423462233661117_)"
    },
    cx: 133.8,
    cy: 102.9,
    rx: 86,
    ry: 47.2
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M133.8,148.6c-47,0-85.3-20.7-86-46.4c0,0.3,0,0.5,0,0.8c0,26.1,38.5,47.2,86,47.2c47.5,0,86-21.1,86-47.2 c0-0.3,0-0.5,0-0.8C219,127.9,180.8,148.6,133.8,148.6z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M188.2,94.6c2.5,11.6-24.4,21.5-54.4,21.5c-30.1,0-56-9.7-54.4-21.5c3.2-24.7,12.4-60,16.4-67.2 c4-7.2,13-11.9,31-2.1c6.8,3.7,13.5,2,19.5-0.4c12.5-4.9,24.6-11.5,30.8,10C181.6,50.6,186.5,86.8,188.2,94.6z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M186.3,83.3c-6.7,8.4-28.6,14.7-52.5,14.7c-24.5,0-46.3-6.5-52.6-15.2c-0.7,4.1-1.3,8.1-1.8,11.8 c-1.5,11.8,24.4,21.5,54.4,21.5c30.1,0,56.9-9.9,54.4-21.5C187.8,92.5,187.1,88.5,186.3,83.3z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M121.1,23.1c1.5,5.2,16.9,18.3,29.7,13.4c12.7-5,9.5-10.1-1.3-8.1C138.7,30.5,129.7,28.4,121.1,23.1z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M186.1,82.5c-53,23.8-93-25.2-78.9-62.7c-5.7,0.5-9.4,3.7-11.5,7.6c-4,7.2-13.2,42.5-16.4,67.2 c-1.5,11.8,24.4,21.5,54.4,21.5c30.1,0,56.9-9.9,54.4-21.5C187.7,92.4,187,88,186.1,82.5z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M177.1,47.5c3,12.3,3.1,22.8,0.2,23.5c-2.9,0.7-7.6-8.7-10.6-21c-3-12.3-3.1-22.8-0.2-23.5 C169.4,25.8,174.1,35.2,177.1,47.5z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M174,181.7c-0.7,9.1-3.8,13.6-22.7,23.8C159.8,199.2,171.1,189.4,174,181.7z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.cc2e16872ced767196bd69518abaa8bc.svg";
export { ForwardRef as ReactComponent };